import { render, staticRenderFns } from "./DishBaseTableHeadRow.vue?vue&type=template&id=8fb45380&"
import script from "./DishBaseTableHeadRow.vue?vue&type=script&lang=js&"
export * from "./DishBaseTableHeadRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports